import NavBarTop from "../NavBarTop";
import FormContact from "../components/FormContact";
import BannerContacto from "../components/BannerContacto";
import Footer from "../components/Footer";
import "../stylesIn.css";
import { useParams } from "react-router";
import { Slide, Fade } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import "../slider.css";
import { useEffect, useState } from "react";
import "../modalContact.css";
import FormContactFicha from "../components/FormContactFicha";
import { Helmet } from "react-helmet";
import env from "../config";
import precios from "../precios";

let imagen;
let images;
let motor;
let caracteristicas;
let cabina;
let marcas;
let internas1;
let internas2;
let internas1b;
let internas2b;
let internas;
let medidas;
let medidasMovil;
let audio_motor;
let garantia;
let textoMotor1;
let textoMotor2;
let textoMotor3;
let precio;
let precio1;
let precio2;
let contenedorMarcas;
let tecnologia;
let slide3;
let slide3b;
let contenedorVidaUtil = "Vida útil de más de 1.5 MILLONES de kilómetros";
let nombreCamion;
let bdc;
let bdcFicha =
  "https://bdc.vehicentro.com:9443/ords/ws_vehicentro/api/conexiones/wordpress/WEBFICHTEC";
let nombreSerie;
let camionSerie;
let cuotas;
let nombreBusqueda;
let urlMedia = env.url;
let euro;
let pathUrl;
let seo;

function Camion() {
  const [modalFormIsOpen, setFormIsOpen] = useState(false);

  useEffect(() => {
    const motorPlayer = document.getElementById("audioMotor");
    motorPlayer.src = audio_motor;

    const keyDownHandler = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        closeFormContact();
      }
    };

    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, []);

  function openFormContact() {
    setFormIsOpen(true);
  }

  function closeFormContact() {
    setFormIsOpen(false);
  }

  //Comparacion paginas
  switch (useParams("id").id) {
    //TX250CAMION
    case "TX-250-4x2-PBV-17.000-Chasis":
      euro = urlMedia + "euro6.png";
      pathUrl = "TX-250-4x2-PBV-17.000-Chasis";
      seo = "";
      nombreCamion = "HOWO TX 250 4x2 PBV 17.000 Chasís";
      camionSerie = "HOWO TX 250 4x2 PBV 17.000 Chasís";
      nombreSerie = "Serie Tx";
      bdc =
        "https://bdcco.vehicentro.com:8443/ords/ws_vehicentro/api/conexiones/web/WEBVHCOTX250";
      images = [
        //urlMedia + "12-toneladas/camion-blanco-sinotruk-de-12-toneladas-ecuador.webp",
        urlMedia + "portadasTresCuartos/TX_250_WEB.webp",
      ];
      textoMotor1 = "";
      textoMotor2 = "TX 250 4x2 PBV 17.000 Chasís";
      textoMotor3 = "Ficha técnica";
      precio = precios.tx_17000;
      precio1 = precios.tx_170001;
      precio2 = precios.tx_170002;
      cuotas = precios.iva;
      motor = urlMedia + "17000/motor17000.jpg";
      //garantia = urlMedia + "12-toneladas/5-anos-de-garantia.webp";
      garantia = urlMedia + "garantiaVacio.webp";
      tecnologia = urlMedia + "TX460TRACTOR6X4/ta.webp";
      caracteristicas = [
        urlMedia + "12-toneladas/camion-de-12-toneladas-potencia-240hp.webp",
        urlMedia +
          "12-toneladas/camion-de-12-toneladas-6-cilindros-en-linea.webp",
        urlMedia + "newFreno.png",
        urlMedia + "250Peso.png",
      ];
      cabina = urlMedia + "17000/Cabina.jpg";
      marcas = urlMedia + "12-toneladas/marcas-vehicentro.webp";
      internas1 = [urlMedia + "17000/Vidrios.jpg"];
      internas2 = [urlMedia + "17000/Palanca.jpg"];
      internas1b = [urlMedia + "17000/Aire-AC.jpg"];
      internas2b = [urlMedia + "17000/Volante.jpg"];
      medidas = urlMedia + "medidas/17000Medidas.webp";
      medidasMovil = urlMedia + "medidas/17000MedidasCelu.webp";
      audio_motor = urlMedia + "12-toneladas/motor.mp3";

      internas = internas1.concat(internas2);
      contenedorVidaUtil = "Vida útil de más de 1.5 MILLONES de kilómetros";
      contenedorMarcas = (
        <div className="boxRightHeader  half" style={{ width: "100 %" }}>
          <img
            src={marcas}
            width="1500"
            height="750"
            className="slideMain"
            alt="marcas "
          />
        </div>
      );

      internas = internas1
        .concat(internas2)
        .concat(internas1b)
        .concat(internas2b);
      //loop slider

      slide3 = internas1b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));

      slide3b = internas2b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));

      contenedorMarcas = (
        <div style={{ display: `contents` }}>
          {internas1b.length > 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <Fade>{slide3}</Fade>
            </div>
          )}
          {internas1b.length == 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <img src={internas1b[0]} alt="" />
            </div>
          )}

          {internas2b.length > 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <Fade>{slide3b}</Fade>
            </div>
          )}
          {internas2b.length == 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <img src={internas2b[0]} alt="" />
            </div>
          )}
        </div>
      );

      contenedorVidaUtil = (
        <div className="banner">
          <img src={urlMedia + "3.5-toneladas/homologado.webp"} />
        </div>
      );

      slide3 = internas1b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));

      slide3b = internas2b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));

      break;
    //FRSCAMION
    case "FRS-10.4-Ton-Super-Turbo":
      euro = urlMedia + "euro6.png";
      pathUrl = "FRS-10.4-Ton-Super-Turbo";
      seo = "";
      nombreCamion = "Chasis FRS PBV";
      camionSerie = "Chasis FRS PBV";
      nombreBusqueda = "Chasis FRS PBV";
      nombreSerie = "Serie 100";
      bdc =
        "https://bdcco.vehicentro.com:8443/ords/ws_vehicentro/api/conexiones/web/WEBVHCOFRS";
      images = [
        //urlMedia + "8-toneladas/camion-blanco-sinotruk-de-8-toneladas-ecuador.webp",
        urlMedia + "portadasTresCuartos/FRS_WEB.webp",
      ];
      textoMotor1 = "";
      textoMotor2 = "FRS 10.4 Ton Súper Turbo";
      textoMotor3 = "Ficha técnica";
      precio = precios.chasis_frs;
      cuotas = precios.iva;
      motor = urlMedia + "frs/motorCummis.webp";
      garantia = urlMedia + "garantiaVacio.webp";
      tecnologia = urlMedia + "frs/cumminsLogo.png";
      caracteristicas = [
        urlMedia + "3.5-toneladas/camion-de-3.5-toneladas-potencia-87hp.webp",
        urlMedia + "8-toneladas/camion-de-8-toneladas-cilindraje.webp",
        urlMedia + "newFreno.png",
        urlMedia + "frsPeso.png",
      ];
      cabina = urlMedia + "frs/Cabina.jpg";
      marcas = urlMedia + "8-toneladas/marcas-vehicentro.webp";
      internas1 = [urlMedia + "frs/Radio.jpg"];
      internas2 = [urlMedia + "frs/Volante.jpg"];
      internas1b = [urlMedia + "frs/Palanca.jpg"];
      internas2b = [urlMedia + "frs/Vidrios.jpg"];
      medidas = urlMedia + "medidas/frsMedidas.webp";
      medidasMovil = urlMedia + "medidas/frsMedidasCelu.webp";
      audio_motor = urlMedia + "8-toneladas/motor.mp3";

      internas = internas1
        .concat(internas2)
        .concat(internas1b)
        .concat(internas2b);
      //loop slider

      slide3 = internas1b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));

      slide3b = internas2b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));

      contenedorMarcas = (
        <div style={{ display: `contents` }}>
          {internas1b.length > 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <Fade>{slide3}</Fade>
            </div>
          )}
          {internas1b.length == 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <img src={internas1b[0]} alt={`Internas 1 ${nombreBusqueda}`} />
            </div>
          )}

          {internas2b.length > 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <Fade>{slide3b}</Fade>
            </div>
          )}
          {internas2b.length == 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <img src={internas2b[0]} alt={`Internas 2 ${nombreBusqueda}`} />
            </div>
          )}
        </div>
      );

      contenedorMarcas = (
        <div className="boxRightHeader  half" style={{ width: "100 %" }}>
          <img
            src={marcas}
            width="1500"
            height="750"
            className="slideMain"
            alt="Punto de Venta"
          />
        </div>
      );
      contenedorVidaUtil = "Vida útil de más de 1.5 MILLONES de kilómetros";

      internas = internas1
        .concat(internas2)
        .concat(internas1b)
        .concat(internas2b);
      //loop slider

      slide3 = internas1b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));

      slide3b = internas2b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));

      contenedorMarcas = (
        <div style={{ display: `contents` }}>
          {internas1b.length > 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <Fade>{slide3}</Fade>
            </div>
          )}
          {internas1b.length == 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <img src={internas1b[0]} alt="" />
            </div>
          )}

          {internas2b.length > 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <Fade>{slide3b}</Fade>
            </div>
          )}
          {internas2b.length == 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <img src={internas2b[0]} alt="" />
            </div>
          )}
        </div>
      );

      contenedorVidaUtil = (
        <div className="banner">
          <img src={urlMedia + "3.5-toneladas/homologado.webp"} />
        </div>
      );
      break;

    //NQSCAMION
    case "NQS-9.9-Ton":
      euro = urlMedia + "euro6.png";
      pathUrl = "NQS-9.9-Ton";
      seo = `Vehicentro, importadores oficiales de la marca Sinotruk en Colombia, te ofrece el ${nombreBusqueda} NQS. Este camión, del modelo ${nombreCamion} de la serie ${nombreSerie} es ideal para cualquier tipo de carga`;
      nombreBusqueda = "camión turbo";
      nombreCamion = "Chasis NQS PBV";
      camionSerie = "Chasis NQS PBV";
      nombreSerie = "Serie 100";
      bdc =
        "https://bdcco.vehicentro.com:8443/ords/ws_vehicentro/api/conexiones/web/WEBVHCONQS";
      images = [
        // urlMedia + "8-toneladas/camion-blanco-sinotruk-de-8-toneladas-ecuador.webp",
        urlMedia + "portadasTresCuartos/NQS_WEB.webp",
      ];
      textoMotor1 = "";
      textoMotor2 = "Chasís NQS PBV";
      textoMotor3 = "Ficha técnica";
      precio = precios.chasis_nqs;
      cuotas = precios.iva;
      motor = urlMedia + "frs/motorCummis.webp";
      garantia = urlMedia + "garantiaVacio.webp";
      euro = urlMedia + "euro6.png";
      tecnologia = urlMedia + "frs/cumminsLogo.png";
      caracteristicas = [
        urlMedia + "3.5-toneladas/camion-de-3.5-toneladas-potencia-87hp.webp",
        urlMedia + "8-toneladas/camion-de-8-toneladas-cilindraje.webp",
        urlMedia + "newFreno.png",
        urlMedia + "PESO-NQS2.png",
      ];
      cabina = urlMedia + "frs/Cabina.jpg";
      marcas = urlMedia + "8-toneladas/marcas-vehicentro.webp";
      internas1 = [urlMedia + "frs/Radio.jpg"];
      internas2 = [urlMedia + "frs/Volante.jpg"];
      internas1b = [urlMedia + "frs/Palanca.jpg"];
      internas2b = [urlMedia + "frs/Vidrios.jpg"];
      medidas = urlMedia + "medidas/nqsMedidas.webp";
      medidasMovil = urlMedia + "medidas/nqsMedidasCelu.webp";
      audio_motor = urlMedia + "8-toneladas/motor.mp3";

      contenedorMarcas = (
        <div className="boxRightHeader  half" style={{ width: "100 %" }}>
          <img
            src={marcas}
            width="1500"
            height="750"
            className="slideMain"
            alt="Punto de Venta"
          />
        </div>
      );
      contenedorVidaUtil = "Vida útil de más de 1.5 MILLONES de kilómetros";

      internas = internas1
        .concat(internas2)
        .concat(internas1b)
        .concat(internas2b);
      //loop slider

      slide3 = internas1b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));

      slide3b = internas2b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));

      contenedorMarcas = (
        <div style={{ display: `contents` }}>
          {internas1b.length > 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <Fade>{slide3}</Fade>
            </div>
          )}
          {internas1b.length == 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <img src={internas1b[0]} alt="" />
            </div>
          )}

          {internas2b.length > 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <Fade>{slide3b}</Fade>
            </div>
          )}
          {internas2b.length == 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <img src={internas2b[0]} alt="" />
            </div>
          )}
        </div>
      );

      contenedorVidaUtil = (
        <div className="banner">
          <img src={urlMedia + "3.5-toneladas/homologado.webp"} />
        </div>
      );

      slide3 = internas1b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));

      slide3b = internas2b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));
      break;

    //NHS
    case "chasis-nhs-pbv":
      euro = urlMedia + "euro6.png";
      pathUrl = "NQS-9.9-Ton";
      seo = `Vehicentro, importadores oficiales de la marca Sinotruk en Colombia, te ofrece el ${nombreBusqueda} NQS. Este camión, del modelo ${nombreCamion} de la serie ${nombreSerie} es ideal para cualquier tipo de carga`;
      nombreBusqueda = "camión turbo";
      nombreCamion = "Chasis NHS PBV";
      camionSerie = "Chasis NHS PBV";
      nombreSerie = "Serie 100";
      bdc =
        "https://bdcco.vehicentro.com:8443/ords/ws_vehicentro/api/conexiones/web/WEBVHCONHS";
      images = [
        // urlMedia + "8-toneladas/camion-blanco-sinotruk-de-8-toneladas-ecuador.webp",
        urlMedia + "NHS/tresCuartos.webp",
      ];
      textoMotor1 = "";
      textoMotor2 = "Chasis NHS PBV";
      textoMotor3 = "Ficha técnica";
      precio = precios.chasis_nhs;
      precio1 = precios.chasis_nhs1;
      precio2 = precios.chasis_nhs2;
      cuotas = precios.iva;
      motor = urlMedia + "NHS/motor.webp";
      garantia = urlMedia + "garantiaVacio.webp";
      euro = urlMedia + "euro6.png";
      tecnologia = urlMedia + "WEICHAI.webp";
      caracteristicas = [
        urlMedia + "3.5-toneladas/camion-de-3.5-toneladas-potencia-87hp.webp",
        urlMedia + "8-toneladas/camion-de-8-toneladas-cilindraje.webp",
        urlMedia + "newFreno.png",
        urlMedia + "/NHS/peso.webp",
      ];
      cabina = urlMedia + "frs/Cabina.jpg";
      marcas = urlMedia + "8-toneladas/marcas-vehicentro.webp";
      internas1 = [urlMedia + "frs/Radio.jpg"];
      internas2 = [urlMedia + "frs/Volante.jpg"];
      internas1b = [urlMedia + "frs/Palanca.jpg"];
      internas2b = [urlMedia + "frs/Vidrios.jpg"];
      medidas = urlMedia + "NHS/medidas.webp";
      medidasMovil = urlMedia + "NHS/medidasCell.webp";
      audio_motor = urlMedia + "8-toneladas/motor.mp3";

      contenedorMarcas = (
        <div className="boxRightHeader  half" style={{ width: "100 %" }}>
          <img
            src={marcas}
            width="1500"
            height="750"
            className="slideMain"
            alt="Punto de Venta"
          />
        </div>
      );
      contenedorVidaUtil = "Vida útil de más de 1.5 MILLONES de kilómetros";

      internas = internas1
        .concat(internas2)
        .concat(internas1b)
        .concat(internas2b);
      //loop slider

      slide3 = internas1b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));

      slide3b = internas2b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));

      contenedorMarcas = (
        <div style={{ display: `contents` }}>
          {internas1b.length > 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <Fade>{slide3}</Fade>
            </div>
          )}
          {internas1b.length == 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <img src={internas1b[0]} alt="" />
            </div>
          )}

          {internas2b.length > 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <Fade>{slide3b}</Fade>
            </div>
          )}
          {internas2b.length == 1 && (
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              <img src={internas2b[0]} alt="" />
            </div>
          )}
        </div>
      );

      contenedorVidaUtil = (
        <div className="banner">
          <img src={urlMedia + "3.5-toneladas/homologado.webp"} />
        </div>
      );

      slide3 = internas1b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));

      slide3b = internas2b.map((interna) => (
        <div className="each-slide-effect">
          <div
            style={{ backgroundImage: `url(${interna})`, height: `25vw` }}
          ></div>
        </div>
      ));
      break;
    default:
      break;
  }

  switch (useParams("id").id) {
    case "TX-250-4x2-PBV-17.000-Chasis":
      imagen = urlMedia + "fotografia/TX_250_FOTO.webp";
      break;

    case "FRS-10.4-Ton-Super-Turbo":
      imagen = urlMedia + "fotografia/FRS_FOTO.webp";
      break;

    case "NQS-9.9-Ton":
      imagen = urlMedia + "fotografia/NQS_FOTO.webp";
      break;

    case "chasis-nhs-pbv":
      imagen = urlMedia + "NHS/formulario.webp";
      break;

    default:
      break;
  }

  //loop primer slide
  let slide1 = images.map((image) => (
    <div className="each-slide-effect">
      <div style={{ backgroundImage: `url(${image})`, height: `41vw` }}></div>
    </div>
  ));
  //loop segundo slide

  let slide2 = internas1.map((interna) => (
    <div className="each-slide-effect">
      <div style={{ backgroundImage: `url(${interna})`, height: `25vw` }}></div>
    </div>
  ));

  let slide2b = internas2.map((interna) => (
    <div className="each-slide-effect">
      <div style={{ backgroundImage: `url(${interna})`, height: `25vw` }}></div>
    </div>
  ));
  //loop slide movil
  let slide2c = internas.map((interna) => (
    <div className="each-slide-effect">
      <div style={{ backgroundImage: `url(${interna})`, height: `25vw` }}></div>
    </div>
  ));

  // ---- PÁGINA ----
  return (
    <>
      <Helmet>
        <title>
          {nombreCamion} - Venta de Camiones {nombreSerie} en Colombia -
          Vehicentro
        </title>
        <meta name="description" content={seo}></meta>
        <meta
          name="keywords"
          content={
            "camion, camiones, venta de camiones, camiones en colombia, camiones en venta Colombia, venta camiones Sinotruk, " +
            nombreCamion +
            ", " +
            nombreBusqueda +
            ", " +
            nombreSerie +
            ", " +
            camionSerie
          }
        ></meta>
        <meta name="robots" content="index, follow"></meta>
        <meta property="og:locale" content="es_CO"></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:title"
          content={
            nombreCamion +
            " - Venta de Camiones " +
            nombreSerie +
            " en Colombia - Vehicentro"
          }
        ></meta>
        <meta property="og:description" content={seo}></meta>
        <meta
          property="og:url"
          content={"https://vehicentro.com/co/camiones/" + pathUrl}
        ></meta>
        <meta property="og:site_name" content="Vehicentro"></meta>
        <meta
          property="article:modified_time"
          content="2023-07-26T12:00:00+00:00"
        ></meta>
        <meta property="og:image" content={imagen}></meta>
        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta name="twitter:description" content={seo}></meta>
        <meta name="twitter:label1" content="Tiempo de lectura"></meta>
        <meta name="twitter:data1" content="5 minutos"></meta>
      </Helmet>
      <NavBarTop />
      <div className="boxesIni posRelative content2">
        <div className="boxRight">
          {images.length > 1 && <Slide>{slide1}</Slide>}
          {images.length == 1 && <img src={images[0]} alt="" />}
        </div>
        <div className="boxLeft playMotor contenedorTextoSobrepuesto">
          <img
            src={motor}
            width="1400"
            height="1000"
            className="slideMain"
            alt="Punto de Venta"
          />
          <div className="boxText flex-table row textoSobrepuesto">
            <div onClick={openFormContact} className="flex-row textoMotor1">
              {textoMotor1}
            </div>
            <div onClick={openFormContact} className="flex-row textoMotor2">
              <h1>{`${textoMotor2}`}</h1>
            </div>
            <div onClick={openFormContact} className="flex-row textoMotor3">
              {textoMotor3}
            </div>
            <div
              onClick={openFormContact}
              className="flex-row textoMotorFlecha"
            >
              <img src={urlMedia + "arrow-rojo.png"} alt="arrow" />
            </div>
            <div onClick={openFormContact} className="flex-row textoMotor4">
              Escucha tu motor
            </div>
          </div>
          <div className="boxPlayerMotor ">
            <audio id="audioMotor" controls type="audio/mpeg"></audio>
          </div>
        </div>
      </div>

      <div className="contentProduct">
        <div className="marcasbg textoImagenesProducto">
          <div className="boxRightHeader  half text_icon_left">
            <p className="vidaUtil">DESDE</p>
            {nombreCamion === "Chasis NHS PBV" || nombreCamion === "HOWO TX 250 4x2 PBV 17.000 Chasís" ? (
              <>
            <p className="precioCamiones">{precio}</p>
            <p className="precioCamiones">{precio1}</p>
            <p className="precioCamiones">{precio2}</p>
            </>
            ):(
              <p className="precioCamiones">{precio}</p>
            )}
            <p className="cuotas">{cuotas}</p>
          </div>

          <div className="boxRightHeader  half icon_center moreSpace">
            <div className="banner">
              <img src={tecnologia} />
            </div>
          </div>

          <div className="boxRightHeader  half text_icon_center">
            <div className="banner">
              <img src={euro} />
            </div>
          </div>

          <div className="boxRightHeader  half icon_right">
            <div className="banner">
              <img src={garantia} />
            </div>
          </div>
        </div>

        <div className="boxesIni posRelative partesbg">
          <div className="caracteristicasProductos">
            <img
              src={caracteristicas[0]}
              width="1400"
              height="1000"
              className="slideMain"
              alt="Punto de Venta"
            />
          </div>

          <div className="caracteristicasProductos">
            <img
              src={caracteristicas[1]}
              width="1400"
              height="1000"
              className="slideMain"
              alt="Punto de Venta"
            />
          </div>

          <div className="caracteristicasProductos">
            <img
              src={caracteristicas[2]}
              width="1400"
              height="1000"
              className="slideMain"
              alt="Punto de Venta"
            />
          </div>

          <div className="caracteristicasProductos">
            <img
              src={caracteristicas[3]}
              width="1400"
              height="1000"
              className="slideMain"
              alt="Punto de Venta"
            />
          </div>
        </div>
        <div className="privaty">
          <div className="texto">
            <p>
              Las fotos relacionadas en esta página son de referencia, algunos
              accesorios son parte de la ambientación fotográfica o de otras
              versiones del vehículo. Las ilustraciones muestran también equipos
              opcionales como carrocerías y equipos no pertenecientes a la
              configuración de serie para Colombia. Tras el cierre de la
              publicación (01.06.2024) pueden haberse producido cambios o
              modificaciones en el diseño y/o equipamiento del producto, las
              cuales pedimos verificar en la red de concesionarios. Para mayor
              información sobre el portafolio de productos, precios, garantía y
              financiación visite nuestra red de concesionarios autorizada de
              Vehicentro Colombia S.A.
            </p>
          </div>
        </div>

            {/* 
        <div className="boxesIni posRelative">
          <div className="marcasbg">
            <img
              src={cabina}
              width="1500"
              height="1500"
              className="slideMain"
              alt={`cabina ${nombreBusqueda}`}
            />
          </div>
          
          <div
            className="marcasbg"
            style={{ display: `flex`, flexWrap: `wrap` }}
          >
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              {slide2}
            </div>
            <div
              className="boxRightHeader  half noResponsive"
              style={{ width: `50%` }}
            >
              {slide2b}
            </div>
            <div
              className="boxRightHeader  half responsive"
              style={{ width: `100%` }}
            >
              <Fade>{slide2c}</Fade>
            </div>
            {contenedorMarcas}
          </div>
           
        </div>
           */}
        <div className="bannerMedidas noResponsive">
          <img src={medidas} />
        </div>
        <div className="bannerMedidas responsive">
          <img src={medidasMovil} />
        </div>
      </div>

      <div className="boxesIni posRelative centrado">
        <div className="centrado">
          <img
            src={imagen}
            width="1400"
            height="1000"
            className="slideMain"
            alt="Punto de Venta"
          />
        </div>
        <div>
          <FormContact
            url={bdc}
            camion={nombreCamion}
            serie={nombreSerie}
            camionSerie={camionSerie}
          />
        </div>
      </div>
      <BannerContacto
        url={bdc}
        camion={nombreCamion}
        serie={nombreSerie}
        camionSerie={camionSerie}
      />
      <Footer />

      {modalFormIsOpen && (
        <FormContactFicha
          url={bdcFicha}
          camion={nombreCamion}
          serie={nombreSerie}
          camionSerie={camionSerie}
          close={closeFormContact}
        />
      )}
    </>
  );
}

export default Camion;
